import { render, staticRenderFns } from "./NodeUpdateLogTableAction.vue?vue&type=template&id=496d2b0e&scoped=true"
import script from "./NodeUpdateLogTableAction.vue?vue&type=script&lang=js"
export * from "./NodeUpdateLogTableAction.vue?vue&type=script&lang=js"
import style0 from "./NodeUpdateLogTableAction.vue?vue&type=style&index=0&id=496d2b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d2b0e",
  null
  
)

export default component.exports